import Toast, { ToastShowParams } from "react-native-toast-message";
// adding a time out because the toast might be dismissed caused by react navigation state changes
const TIME_OUT = 500;
export default {
  success: (msg: string, config?: ToastShowParams) => {
    setTimeout(() => {
      Toast.show({
        type: "success",
        text1: msg,
        visibilityTime: 100000,
        ...config,
      });
    }, TIME_OUT);
  },
  error: (msg: string, config?: ToastShowParams) => {
    setTimeout(() => {
      Toast.show({
        type: "error",
        text1: msg,
        visibilityTime: 999999,
        ...config,
      });
    }, TIME_OUT);
  },

  info: (msg: string, config?: ToastShowParams) => {
    setTimeout(() => {
      Toast.show({
        type: "info",
        text1: msg,
        visibilityTime: 100000,
        ...config,
      });
    }, TIME_OUT);
  },

  warning: (msg: string, config?: ToastShowParams) => {
    setTimeout(() => {
      Toast.show({
        type: "warning",
        text1: msg,
        visibilityTime: 100000,
        ...config,
      });
    }, TIME_OUT);
  },
};
